import React from 'react'

import { SimpleLoader } from './catalog/SwaapLoader'

export const Loader = SimpleLoader
